import * as React from "react";
import { BasePathContext, useBasePath } from "../../reactContexts/basePathContext";
import { MarketplaceTemplateList } from "./template/templateList";
import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "../../layout";
import { MarketplaceTemplateInstall } from "./template/templateInstall";
import { MarketplaceReleaseList } from "./release/list";
import { MarketplaceReleaseDetail } from "./release/detail";
import { MarketplaceTemplateDetail } from "./template/templateDetail";
import { MarketplaceLegacyReleaseDetail } from "./release/legacy/legacyDetail";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";

const MarketplaceRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  const basePath = useBasePath("/marketplace/*");

  return (
    <BasePathContext.Provider value={basePath}>
      <Layout key={org}>
        <div className="marketplace h-full">
          <Routes>
            <Route index element={<Navigate to={`release`} />} />
            <Route path={`template`} element={<MarketplaceTemplateList />} />
            <Route path={`template/:template`} element={<MarketplaceTemplateDetail />} />
            <Route path={`template/:template/install`} element={<MarketplaceTemplateInstall />} />
            <Route path={`release`} element={<MarketplaceReleaseList />} />
            <Route path={`release/legacy/:release/*`} element={<MarketplaceLegacyReleaseDetail />} />
            <Route path={`release/:release/*`} element={<MarketplaceReleaseDetail />} />
          </Routes>
        </div>
      </Layout>
    </BasePathContext.Provider>
  );
};

export default MarketplaceRoute;
